// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_overlayCustom__ohqNz {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles_modalWrapper__PV\\+BJ {
  display: flex;
  width: 520px !important;
  min-height: 300px !important;
  max-height: calc(100% - 64px) !important;
  margin-top: 32px;
  margin-right: 32px;
  background: #100f0f !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 32px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);
  color: #ffffff;
}
@media (max-width: 768px) {
  .styles_modalWrapper__PV\\+BJ {
    width: 90% !important;
    height: -moz-fit-content !important;
    height: fit-content !important;
    margin-top: 0;
    margin-right: 0;
  }
}

.styles_wrapper__RoWHN {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  gap: 24px;
}

.styles_headingWrapper__2Em1L {
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  text-align: center;
}

.styles_heading__vleyy {
  font-weight: 800;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
}
@media (max-width: 768px) {
  .styles_heading__vleyy {
    font-size: 18px;
  }
}

.styles_content__TSeM2 {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  padding: 0 24px 24px;
}

.styles_message__Yww-F {
  flex: 1 1;
  color: rgba(255, 255, 255, 0.5);
}
.styles_message_title__\\+EJW7 {
  color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 10px;
}
.styles_message_link__j0hAv {
  color: #ffffff;
}

.styles_action__iaH0I {
  height: 46px;
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/informationModal/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,QAAA;EACA,8BCWS;EDVT,kCAAA;UAAA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,qCAAA;EACA,mBAAA;EACA,2CAAA;EACA,cCzBM;ADuBR;AEQE;EFjBF;IAcI,qBAAA;IACA,mCAAA;IAAA,8BAAA;IACA,aAAA;IACA,eAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,eAAA;EACA,kDAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;AADF;AErBE;EFiBF;IAQI,eAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,SAAA;EACA,+BC/DS;AD+DX;AAEE;EACE,cCxEI;EDyEJ,eAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,cC/EI;AD8ER;;AAKA;EACE,YAAA;EACA,gBAAA;AAFF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.overlayCustom {\n  position: fixed;\n  inset: 0;\n  background: $black-30;\n  backdrop-filter: blur(3px);\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalWrapper {\n  display: flex;\n  width: 520px !important;\n  min-height: 300px !important;\n  max-height: calc(100% - 64px) !important;\n  margin-top: 32px;\n  margin-right: 32px;\n  background: $black-bg !important;\n  border: 1px solid $black-15;\n  border-radius: 32px;\n  box-shadow: 0 30px 60px $black-5;\n  color: $white;\n\n  @include md {\n    width: 90% !important;\n    height: fit-content !important;\n    margin-top: 0;\n    margin-right: 0;\n  }\n}\n\n.wrapper {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.headingWrapper {\n  padding: 12px 0;\n  border-bottom: 1px solid $white-5;\n  text-align: center;\n}\n\n.heading {\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n\n  @include md {\n    font-size: 18px;\n  }\n}\n\n.content {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  padding: 0 24px 24px;\n}\n\n.message {\n  flex: 1;\n  color: $white-50;\n\n  &_title {\n    color: $white;\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 10px;\n  }\n\n  &_link {\n    color: $white;\n  }\n}\n\n.action {\n  height: 46px;\n  margin-top: 16px;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayCustom": `styles_overlayCustom__ohqNz`,
	"modalWrapper": `styles_modalWrapper__PV+BJ`,
	"wrapper": `styles_wrapper__RoWHN`,
	"headingWrapper": `styles_headingWrapper__2Em1L`,
	"heading": `styles_heading__vleyy`,
	"content": `styles_content__TSeM2`,
	"message": `styles_message__Yww-F`,
	"message_title": `styles_message_title__+EJW7`,
	"message_link": `styles_message_link__j0hAv`,
	"action": `styles_action__iaH0I`
};
export default ___CSS_LOADER_EXPORT___;
